import { useSelector, useDispatch } from "react-redux";
import { setLangAsync } from "./i18nSlice";
import { useEffect } from 'react';

export default function useTranslations() {
  const dispatch = useDispatch();

  const t = useSelector((state) => state.i18n.translations);
  const setLang = (lang) => {
    try {
      console.log("switch lang:",lang)
      localStorage.setItem("lang", lang);
    } catch (e) {
      console.log(e);
    }
    return dispatch(setLangAsync(lang))
  };

  const lang = useSelector((state) => state.i18n.lang);
  const supportedLangs = useSelector(
    (state) => state.i18n.supportedLangs,
  );
  const status = useSelector((state) => state.i18n.status);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return {
    t,
    lang,
    setLang,
    init: setLang,
    supportedLangs,
    status,
  };
}
